module.exports = window.jQuery;


//////////////////
// WEBPACK FOOTER
// external "window.jQuery"
// module id = 2
// module chunks = 62